export default __webpack_public_path__ + "static/media/hp-learning-snippet-img.420c0aa3.svg";